import type { ClipboardEvent, KeyboardEvent } from 'react'
import { forwardRef, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { MIN_HEIGHT } from './chat-input-composer.config'

interface ChatInputTextareaProps {
  value: string
  placeholder: string
  maxHeight: number
  isDisabled: boolean
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void
  onPaste: (e: ClipboardEvent<HTMLTextAreaElement>) => void
}

/**
 * Textarea component for composing chat messages.
 */
export const ChatInputTextarea = forwardRef<HTMLTextAreaElement, ChatInputTextareaProps>(
  ({ value, placeholder, maxHeight, isDisabled, onChange, onKeyDown, onPaste }, ref): ReactNode => (
    <div className="px-3 pt-3">
      <textarea
        ref={ref}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        placeholder={placeholder}
        disabled={isDisabled}
        rows={1}
        className={cn(
          'chat-input-textarea w-full resize-none bg-transparent text-sm outline-none',
          'placeholder:text-muted-foreground',
          'disabled:cursor-not-allowed'
        )}
        style={{ minHeight: MIN_HEIGHT, maxHeight }}
      />
    </div>
  )
)

ChatInputTextarea.displayName = 'ChatInputTextarea'
